/* eslint-disable no-useless-concat */
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { useForm } from '../hooks/useForm';
import { useLocation, useNavigate } from 'react-router-dom';

import { BrujoContext } from '../Context/BrujoContext';

import queryString from 'query-string';
import { BusquedaInput } from '../components/BusquedaInput';
import { SelectionSearch } from '../components/SelectionSearch';
import { DetalleArticulo } from '../components/DetalleArticulo';
import { FootPage } from '../ui/FootPage';

let arrayPages = [];

export const Home = () => {
  
  const navigate = useNavigate();
  const location = useLocation();

  const { paginate = '',
          search = '',
          detalle = '',
          cod = '',
          cultural = '',
          material = '',
          periodo = '',
          objeto = '',
          prov = '', } = queryString.parse( location.search );

  const { periodos,
          tipoObjetos,
          proveniencias,
          materiales,
          culturas,
          apiSearchTermino,
          searchAutocomplete } = useContext(BrujoContext);

  const [listSearchAutocomplete, setListSearchAutoComplete] = useState([]);
  const [listResultSearch, setListResultSearch] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [numPages, setNumPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [viewDetalle, setViewDetalle] = useState(false);
  
  const {searchText, codigomuseo, filiacion_cultural_id, tipo_material_id, periodo_id, tipo_objeto_id, proveniencia_codigo, onInputChange } = useForm({
    searchText: '',
    codigomuseo: '',
    filiacion_cultural_id: 0,
    tipo_material_id: 0,
    periodo_id: 0,
    tipo_objeto_id: 0,
    proveniencia_codigo: '',
  });

  useEffect(() => {
    if (detalle !== "") {
      setViewDetalle(true)
    } else {
      if (search !== "" | cod !== "" | cultural !== "" | material !== "" | periodo !== "" | objeto !== "" | prov !== "" ) {
        onSearchResultInput((search === "" ? "" : search), (cod === "" ? "" : cod), (cultural === "" ? 0 : cultural), (material === "" ? 0 : material), (periodo === "" ? 0 : periodo), (objeto === "" ? 0 : objeto), (periodo === "" ? "" : periodo))
      }
    }
  },[] );

  useEffect(() => {
    searchWithAutocomplete();
  }, [searchText]);

  useEffect(() => {
    if (location.search === "") {
      limpiar();
      setViewDetalle(false);
    }
  }, [location.search])
  

  const searchWithAutocomplete = async() => {
    if (searchText.trim().length <= 2 ){
      setListSearchAutoComplete([])
    } else {
      const resp = await searchAutocomplete(searchText);
      setListSearchAutoComplete(resp.terms);
    }
  }

  const limpiar = () => {
    setListResultSearch([]);
    arrayPages = [];
    setCurrentPage(0);
    navigate('');
  }

  const onSearchResultInput = async(termino, codigomuseo, filiacion_cultural_id, tipo_material_id, periodo_id, tipo_objeto_id, proveniencia_codigo) => {
    setIsLoading(true);
    limpiar();
    await apiSearchTermino(termino, codigomuseo, filiacion_cultural_id, tipo_material_id, periodo_id, tipo_objeto_id, proveniencia_codigo).then(resp => {
      let div = resp.total / 12;

      if (termino !== "") {
        navigate(`?paginate=1&search=${termino.toLowerCase()}`)
      } else {
        navigate(`?paginate=1` + 
                `${codigomuseo !== "" ? "&cod=" + codigomuseo : ""}` + 
                `${filiacion_cultural_id !== 0 ? "&cultural="+ filiacion_cultural_id : ""}` + 
                `${tipo_material_id !== 0 ? "&material=" + tipo_material_id: ""}` + 
                `${periodo_id !== 0 ? "&periodo=" + periodo_id : ""}` + 
                `${tipo_objeto_id !== 0 ? "&objeto=" + tipo_objeto_id : ""}` + 
                `${proveniencia_codigo !== "" ? "&prov=" + proveniencia_codigo : ""}`)
      }
      setTimeout(() => {
        arrayPages = [];
        if (div - Math.floor(div) === 0) {
          for (let index = 0; index < div; index++) {
            arrayPages.push(index + 1)
          }
        } else {
          setNumPages(parseInt(div) + 1);
          for (let index = 0; index < parseInt(div) + 1; index++) {
            arrayPages.push(index + 1)
          }
        }
        setListResultSearch(resp.piezas);
        setListSearchAutoComplete([]);
        setIsLoading(false);
      }, 2000);
    });
  }

  const filteredColecciones = () => {
    return listResultSearch.slice(currentPage, currentPage + 12);
  }

  const nextPage = () => {
    let nextP = parseInt(paginate) + 1;
    if (nextP <= numPages) {
      setIsLoading(true);
      navigate(`?paginate=${nextP}` + 
              `${search !== "" ? "&search=" + search : ""}` +
              `${cod !== "" ? "&cod=" + cod : ""}` +
              `${cultural !== "" ? "&cultural="+ cultural : ""}` + 
              `${material !== "" ? "&material=" + material : ""}` + 
              `${periodo !== "" ? "&periodo=" + periodo : ""}` + 
              `${objeto !== "" ? "&objeto=" + objeto : ""}` + 
              `${prov !== "" ? "&prov=" + prov : ""}`)
      setTimeout(() => {
        setCurrentPage(currentPage + 12);
        setIsLoading(false);
      }, 2000);
    }
  }

  const previewPage = () => {
    if (paginate !== '1') {
      setIsLoading(true);
      let pervP = parseInt(paginate) - 1;
      navigate(`?paginate=${pervP}` + 
              `${search !== "" ? "&search=" + search : ""}` +
              `${cod !== "" ? "&cod=" + cod : ""}` +
              `${cultural !== "" ? "&cultural="+ cultural : ""}` + 
              `${material !== "" ? "&material=" + material : ""}` + 
              `${periodo !== "" ? "&periodo=" + periodo : ""}` + 
              `${objeto !== "" ? "&objeto=" + objeto : ""}` + 
              `${prov !== "" ? "&prov=" + prov : ""}`)
      setTimeout(() => {
        setCurrentPage(currentPage - 12)
        setIsLoading(false);
      }, 2000);
    }
  }

  const ocultarViewDetalle = () => {
    if (search !== "" | cod !== "" | cultural !== "" | material !== "" | periodo !== "" | objeto !== "" | prov !== "" ) {
      onSearchResultInput((search === "" ? "" : search), (cod === "" ? "" : cod), (cultural === "" ? 0 : cultural), (material === "" ? 0 : material), (periodo === "" ? 0 : periodo), (objeto === "" ? 0 : objeto), (periodo === "" ? "" : periodo))
    }
    setViewDetalle(false);
  }

  const viewDetalleArticule = (value) => {
    navigate(`${location.search}&detalle=${value}#detalle`);
    setViewDetalle(true);
  }

  const goPageSelect = (value) => {
    setIsLoading(true);
    let seleccion = 12 * parseInt(value);
    navigate(`?paginate=${value}` + 
            `${search !== "" ? "&search=" + search : ""}` +
            `${cod !== "" ? "&cod=" + cod : ""}` +
            `${cultural !== "" ? "&cultural="+ cultural : ""}` + 
            `${material !== "" ? "&material=" + material : ""}` + 
            `${periodo !== "" ? "&periodo=" + periodo : ""}` + 
            `${objeto !== "" ? "&objeto=" + objeto : ""}` + 
            `${prov !== "" ? "&prov=" + prov : ""}`)
    setTimeout(() => {
      setCurrentPage(seleccion - 12)
      setIsLoading(false);
    }, 2000);
  }
  

  return (
    <>
    <div className='wrapperContainer'>
      <BusquedaInput searchText={searchText} onInputChange={onInputChange} listSearchAutocomplete={listSearchAutocomplete} onSearchResultInput={onSearchResultInput} />
      <div className='wrapperBanner'>
        <div className='contentBanner'>
          <div className='textoBanner'>
            <h2>
              Catálogo de Piezas Arqueológicas
            </h2>
            <div className='separator' />
            <p>
                              Nuestra Plataforma Digital para la Gestión de Colecciones Arqueológicas tiene como objetivo poner a disposición del mundo la colección de bienes culturales muebles rescatados por la Fundación Wiese en los últimos 30 años en el Complejo Arqueológico El Brujo. Mantenemos nuestro compromiso de compartir estas colecciones de forma gratuita, con contenido constantemente actualizado y mejorado por nuestro equipo de arqueólogos.
            </p>
          </div>
          <div className="imgBanner">
            <img className='imageBanner' src="./assets/img/banner.jpg" alt="" />
          </div>
        </div>
      </div>
      <div className="footSearch">
        <div className="contentSearch">
          <div className="itemLeft">
            <h4>
              Búsqueda avanzada
            </h4>

            <div className='separator' />

            <label htmlFor="codigomuseo">
              Código Museo
            </label>
            <input id='codigomuseo' name='codigomuseo' value={codigomuseo} onChange={onInputChange} />

            <SelectionSearch label={"Filiación Cultural"} name={"filiacion_cultural_id"} value={filiacion_cultural_id} onInputChange={onInputChange} array={culturas} />

            <SelectionSearch label={"Tipo de Material"} name={"tipo_material_id"} value={tipo_material_id} onInputChange={onInputChange} array={materiales} />

            <SelectionSearch label={"Periodo"} name={"periodo_id"} value={periodo_id} onInputChange={onInputChange} array={periodos} />

            <SelectionSearch label={"Tipo de Objeto"} name={"tipo_objeto_id"} value={tipo_objeto_id} onInputChange={onInputChange} array={tipoObjetos} />

            <SelectionSearch label={"Procedencia"} name={"proveniencia_codigo"} value={proveniencia_codigo} onInputChange={onInputChange} array={proveniencias} />

            <button onClick={() => { onSearchResultInput("", codigomuseo, filiacion_cultural_id, tipo_material_id, periodo_id, tipo_objeto_id, proveniencia_codigo) }}>
              Buscar
            </button>
          </div>
          <div className='itemRight'>
            {
              (!viewDetalle)
                ? <>
                    <div className='sectionResults' style={{ display: (isLoading) && 'flex' }}>
                      {
                        (!isLoading)
                          ? filteredColecciones().map((item, index) => {
                              return(
                                <div key={index} className={'itemResult s' + item.pie_id} onClick={ () => {viewDetalleArticule(item.pie_id)} }>
                                  <figure>
                                    {
                                      (item.imagen[0] !== undefined)
                                        ? <img src={item.imagen[0]} className='imgArticles' alt={item.cul_name}/>
                                        : <img src='./assets/img/no-imagen.jpg' className='imgArticles' alt={item.cul_name}/>
                                    }
                                    <div className='desciptionImage'>
                                      <p>{ item.pie_code }</p>
                                      <p>Objeto: { item.tob_name }</p>
                                      <p>Cultura: { item.cul_name }</p>
                                    </div>
                                  </figure>
                                </div>
                              )
                            })
                          : <img className='imageLoading' src='./assets/img/loading.gif' alt='loading' />
                      }
                    </div> 
                    <ul className={listResultSearch.length === 0 ? 'invisible' : 'pagination'}>
                      <li onClick={previewPage}>
                        &#60;
                      </li>
                      {
                        arrayPages.map((item, index) => {
                          return(
                            <li key={index} onClick={() => {goPageSelect(item)}} className={(parseInt(paginate) === item) ? "backgroundPagination" : ""}>
                              {item}
                            </li>
                          )
                        })
                      }
                      <li onClick={nextPage}>
                        &#62;
                      </li>
                    </ul>
                  </>
                : <DetalleArticulo ocultarViewDetalle={ocultarViewDetalle} />
            }
          </div>
        </div>
      </div>
    </div>
    <FootPage />
    </>
  )
}
